// extracted by mini-css-extract-plugin
export default {"mdc-card--app":"GenericForm_mdc-card--app__BSvtV","flex-container":"GenericForm_flex-container__kpG26"};